/**
 * src/utils/constants.js
 * Application constants and placeholder structures.
 */

export const SUGGESTION_CHIPS = [
  {
    label: "💼 Software Developer Resume",
    reply: "I'm a Software Developer with 3 years experience in React, Node.js and Python. Help me build a resume.",
  },
  {
    label: "🎓 MBA / Business Resume",
    reply: "I have an MBA and 5 years in business strategy and operations. Help me build a professional resume.",
  },
  {
    label: "📣 Marketing Resume",
    reply: "I'm a Marketing Manager with expertise in digital marketing, SEO, and brand campaigns. Help me build a resume.",
  },
];

export const SAMPLE_RESUME_DATA = {
  name: "Arjun Sharma",
  title: "Senior Software Engineer",
  email: "arjun.sharma@email.com",
  phone: "+91 98765 43210",
  location: "Bangalore, India",
  linkedin: "linkedin.com/in/arjunsharma",
  summary: "Results-driven Software Engineer with 5+ years building scalable web applications. Experienced in full-stack development with React, Node.js, and cloud infrastructure. Passionate about clean code, performance optimization, and mentoring junior engineers.",
  experience: [
    {
      company: "Infosys Limited",
      role: "Senior Software Engineer",
      duration: "Jan 2022 – Present",
      location: "Bangalore",
      points: [
        "Led development of a microservices platform serving 2M+ daily active users, reducing latency by 40%",
        "Architected React + TypeScript frontend that improved page load speed by 55%",
        "Mentored a team of 5 junior developers and conducted code reviews",
        "Implemented CI/CD pipelines using GitHub Actions, cutting deployment time from 2 hours to 15 minutes",
      ],
    },
    {
      company: "TCS Digital",
      role: "Software Engineer",
      duration: "Jun 2019 – Dec 2021",
      location: "Hyderabad",
      points: [
        "Built RESTful APIs in Node.js for a fintech platform processing ₹50Cr+ monthly transactions",
        "Integrated third-party payment gateways (Razorpay, PayU) with 99.9% uptime",
        "Reduced database query time by 60% through indexing and query optimization",
      ],
    },
  ],
  education: [
    {
      institution: "National Institute of Technology, Warangal",
      degree: "B.Tech in Computer Science",
      year: "2019",
      grade: "8.7 CGPA",
    },
  ],
  skills: ["React", "TypeScript", "Node.js", "Python", "PostgreSQL", "Redis", "AWS", "Docker", "Kubernetes", "Git"],
  certifications: ["AWS Certified Solutions Architect", "Google Cloud Professional Developer"],
};
